import { TITLE_PREFIX, WAVES_ROUTE, WAVES_HISTORY_ROUTE } from './consts';

export default () => ({
    waves: {
        id: 'Waves',
        label: 'Waves',
        title: `${TITLE_PREFIX} > Waves`,
        link: WAVES_ROUTE,
        permission: 'fulfillments - waves.index',
        order: 10,
    },
    wavesHistory: {
        id: 'Waves History',
        label: 'Waves History',
        title: `${TITLE_PREFIX} > Waves History`,
        link: WAVES_HISTORY_ROUTE,
        permission: 'fulfillments - waves.index',
        order: 20,
    },
});
